<template>
  <iLink v-if="resolvedUrl" :href="resolvedUrl">
    <ContainerProduction v-bind="containerProps">
      <slot />
    </ContainerProduction>
  </iLink>
  <ContainerProduction v-else v-bind="containerProps">
    <slot />
  </ContainerProduction>
</template>

<script>
import App from "@bloglovin/inspire-engine/App";
import ContainerProduction from "%/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import LinkUrlTemplate from "%/dynamic-component-editor/options/link-url-template";
import { resolveLinkUrl } from "%/dynamic-component-editor/standard-elements/link/link-url-template";

export default {
  name: "LinkContainer",
  components: { ContainerProduction },
  production: true,
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  inheritAttrs: false,
  computed: {
    containerProps() {
      return {
        ...this.$attrs,
        optionValues: this.optionValues,
        activeState: this.activeState,
        identifier: this.identifier,
        themeMode: this.themeMode,
        editMode: this.editMode,
      };
    },
    resolvedUrl() {
      const template = this.getOptionValue(LinkUrlTemplate);
      if (!template || !this.contextItem || !this.entityType) {
        return "";
      }
      return resolveLinkUrl(template, fieldName => this.readEntityField(fieldName));
    },
  },
  methods: {
    readEntityField(fieldName) {
      try {
        return App.get(this.resolvedAppName).getEntityField(
          this.entityType,
          this.contextItem.entityPkUrlVars,
          fieldName,
        );
      } catch {
        return undefined;
      }
    },
  },
};
</script>
